import React, { useState } from 'react'
import './node.css';
import { NodeI } from './pathFinding';
interface Props {
    nodeC: NodeI,
    isMouseDown:boolean,
    obstacle:number,
    onNodeChange: (updatedNode: NodeI) => void;
    onStartDrag?: (row: number, col: number) => void;
    onEndDrag?: (row: number, col: number) => void;
    onNodeDrop?: (row: number, col: number) => void;
}
export default function NodeC({ nodeC,isMouseDown ,obstacle, onNodeChange, onStartDrag, onEndDrag, onNodeDrop}: Props) {
    const [change, setchange] = useState(0);
    
    const handleNodeInteraction = () => {
        if (!nodeC.isSrc && !nodeC.isDest) {
            const updatedNode = { ...nodeC };
            
            if(obstacle === 1){
                updatedNode.isWeight = !updatedNode.isWeight;
                updatedNode.weight = updatedNode.isWeight ? 2 : 1;
                updatedNode.isWall = false;
            } else if(obstacle === 2){
                updatedNode.isWall = !updatedNode.isWall;
                updatedNode.isWeight = false;
                updatedNode.weight = 1;
            } else if(obstacle === 0) {
                updatedNode.isWall = false;
                updatedNode.isWeight = false;
                updatedNode.weight = 1;
            }
            
            onNodeChange(updatedNode);
            setchange(Math.random());
        }
    };
    
    const handleMouseEnter = () => {
        if (isMouseDown) {
            handleNodeInteraction();
        }
    };
    
    const handleMouseClick = () => {
        handleNodeInteraction();
    };
    
    const handleDragStart = (e: React.DragEvent) => {
        if (nodeC.isSrc && onStartDrag) {
            onStartDrag(nodeC.row, nodeC.col);
        } else if (nodeC.isDest && onEndDrag) {
            onEndDrag(nodeC.row, nodeC.col);
        }
    };
    
    const handleDragOver = (e: React.DragEvent) => {
        e.preventDefault();
    };
    
    const handleDrop = (e: React.DragEvent) => {
        e.preventDefault();
        if (onNodeDrop && !nodeC.isSrc && !nodeC.isDest) {
            onNodeDrop(nodeC.row, nodeC.col);
        }
    };
    
    return (
        <div 
            draggable={nodeC.isSrc || nodeC.isDest}
            onMouseEnter={handleMouseEnter}
            onClick={handleMouseClick}
            onDragStart={handleDragStart}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            className={`node ${nodeC.isSrc ? 'source' : ''} 
            ${nodeC.isVisited ? 'visited' : ''} ${nodeC.isDest ? 'dest' : ''} 
            ${nodeC.isPath ? 'path' : ''} ${nodeC.isWeight ? 'weight' : ''} 
            ${nodeC.isWall ? 'wall' : ''}`}
        />
    )
}
